<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.adapters'), $t('adapters.taobao')]">
        <el-button type="success" size="mini" @click="create"
          >+ {{ $t("text.create") }}</el-button
        >
      </breadcrumb>
    </div>
    <div class="table-area">
      <ul style="color: #606266">
        <li class="mgb5">对接需要使用淘宝主账号登陆卖家平台</li>
        <li class="mgb5">简赢对接店铺名称需与淘宝主账号名称一致</li>
      </ul>
    </div>
    <div class="red font16 center pd10">
      您的账户可用{{ taobaoStores }}淘宝账户，现已加入{{ usedTaobaoStores }}个
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <small class="float-right orange">{{
              $t("prompt.taobaoExplain")
            }}</small>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="items"
        id="recordsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="name"
          :title="$t('platform.name')"
          min-width="100"
        />

        <vxe-table-column
          field="accessToken"
          :title="$t('platform.accessToken')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.authTokenAt != null">
              {{ $t("accessTokens.true") }}
            </span>
            <span v-else class="red">{{ $t("accessTokens.false") }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="prefix"
          :title="$t('platform.prefix')"
          min-width="90"
        />
        <vxe-table-column
          field="shopName"
          :title="$t('platform.shop')"
          min-width="80"
        />
        <vxe-table-column
          field="storeOwnerId"
          :title="$t('platform.storeOwnerId')"
          min-width="90"
        >
          <template v-slot="{ row }">
            <span v-if="users.find((u) => u.id == row.storeOwnerId) != null">
              {{ users.find((u) => u.id == row.storeOwnerId).name }}
            </span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="toHandOverAt"
          :title="$t('platform.toHandOverAt')"
          min-width="90"
        />
        <vxe-table-column
          field="asyncTrack"
          :title="$t('platform.asyncTrack')"
          min-width="90"
        >
          <template v-slot="{ row }">
            {{ $t("boolean." + row.asyncTrack) }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="importColor"
          :title="$t('platform.importColor')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ $t("boolean." + row.importColor) }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="importSize"
          :title="$t('platform.importSize')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ $t("boolean." + row.importSize) }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="mergeBargain"
          :title="$t('platform.mergeBargain')"
          min-width="102"
        >
          <template v-slot="{ row }">
            {{ $t("boolean." + row.mergeBargain) }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="cpCode"
          :title="$t('platform.cpCode')"
          min-width="100"
        />
        <vxe-table-column field="action" :title="$t('text.action')" width="150">
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="authorize(row)">{{
              $t("action.authorize")
            }}</el-button>
            <el-button type="text" size="mini" @click="updateCpCode(row)">{{
              $t("action.updateCpCode")
            }}</el-button>
            <div>
              <el-button type="text" size="mini" @click="edit(row)">{{
                $t("text.edit")
              }}</el-button>
              <el-button type="text" size="mini" @click="deleteRow(row)">{{
                $t("text.delete")
              }}</el-button>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="60%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="120px">
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'name'"
              :label="$t('platform.name')"
              :rules="[
                {
                  required: true,
                  validator: validateNameEdit,
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="editObj.name" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'prefix'" :label="$t('platform.prefix')">
              <el-input size="small" v-model.trim="editObj.prefix" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'storeOwnerId'"
              :label="$t('platform.storeOwnerId')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.storeOwnerId')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select size="small" v-model.trim="editObj.storeOwnerId">
                <el-option
                  v-for="user in users"
                  :key="user.id"
                  :label="user.name"
                  :value="user.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'toHandOverAt'"
              :label="$t('platform.toHandOverAt')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.toHandOverAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="editObj.toHandOverAt"
                type="number"
                min="0"
                :placeholder="$t('platform.toHandOverAt')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'shopId'"
              :label="$t('platform.shop')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.shop')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select size="small" v-model.trim="editObj.shopId">
                <el-option
                  v-for="shop in shops"
                  :key="shop.id"
                  :label="shop.name"
                  :value="shop.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'tbUserId'" :label="$t('platform.tbUserId')">
              <el-input
                size="small"
                v-model.trim="editObj.tbUserId"
                :placeholder="$t('platform.tbUserId')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'asyncTrack'"
              :label="$t('platform.asyncTrack')"
            >
              <el-checkbox size="small" v-model="editObj.asyncTrack" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'importColor'"
              :label="$t('platform.importColor')"
            >
              <el-checkbox size="small" v-model.trim="editObj.importColor" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'importSize'"
              :label="$t('platform.importSize')"
            >
              <el-checkbox size="small" v-model.trim="editObj.importSize" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'mergeBargain'"
              :label="$t('platform.mergeBargain')"
            >
              <el-checkbox size="small" v-model.trim="editObj.mergeBargain" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="orange">{{ $t("prompt.toHandOverAtExplain") }}</div>
      <div class="orange" style="margin-left: 35px">
        {{ $t("prompt.mergeBargainExplain") }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="60%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'name'"
              :label="$t('platform.name')"
              :rules="[
                { required: true, validator: validateName, trigger: 'blur' },
              ]"
            >
              <el-input size="small" v-model.trim="addObj.name" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'prefix'" :label="$t('platform.prefix')">
              <el-input size="small" v-model.trim="addObj.prefix" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'storeOwnerId'"
              :label="$t('platform.storeOwnerId')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.storeOwnerId')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select size="small" v-model.trim="addObj.storeOwnerId">
                <el-option
                  v-for="user in users"
                  :key="user.id"
                  :label="user.name"
                  :value="user.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'toHandOverAt'"
              :label="$t('platform.toHandOverAt')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.toHandOverAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input
                size="small"
                v-model.trim="addObj.toHandOverAt"
                type="number"
                min="0"
                :placeholder="$t('platform.day')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'shopId'"
              :label="$t('platform.shop')"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('platform.shop')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select size="small" v-model.trim="addObj.shopId">
                <el-option
                  v-for="shop in shops"
                  :key="shop.id"
                  :label="shop.name"
                  :value="shop.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :prop="'tbUserId'" :label="$t('platform.tbUserId')">
              <el-input
                size="small"
                v-model.trim="addObj.tbUserId"
                :placeholder="$t('platform.tbUserId')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
              :prop="'asyncTrack'"
              :label="$t('platform.asyncTrack')"
            >
              <el-checkbox size="small" v-model.trim="addObj.asyncTrack" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'importColor'"
              :label="$t('platform.importColor')"
            >
              <el-checkbox size="small" v-model.trim="addObj.importColor" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'importSize'"
              :label="$t('platform.importSize')"
            >
              <el-checkbox size="small" v-model.trim="addObj.importSize" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :prop="'mergeBargain'"
              :label="$t('platform.mergeBargain')"
            >
              <el-checkbox size="small" v-model.trim="addObj.mergeBargain" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span class="orange">{{ $t("prompt.toHandOverAtExplain") }}</span>
      <div class="orange" style="margin-left: 35px">
        {{ $t("prompt.mergeBargainExplain") }}
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="saveDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="updateCpCodeDF"
      width="30%"
    >
      <el-form
        ref="updateCpCodeObjForm"
        :model="updateCpCodeObj"
        label-width="80px"
      >
        <el-form-item
          :prop="'cpCode'"
          :label="$t('platform.cpCode')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('platform.cpCode')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="updateCpCodeObj.cpCode"
            :placeholder="$t('platform.cpCode')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="updateCpCodeSubmitDoing"
          size="small"
          @click="updateCpCodeSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="updateCpCodeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Cookies from "@/utils/cookies";
import TaobaoStore from "@/api/adapterTaobaoStore";
import Tenant from "@/api/tenant";
import User from "@/api/user";
import Shop from "@/api/shop";
import Charge from "@/api/charge";

export default {
  mixins: [page],
  components: {},
  data() {
    var validateName = (rule, value, callback) => {
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("platform.name")]))
        );
        return;
      }
      const names = this.items.map((i) => i.name);
      if (names.includes(value)) {
        callback(new Error(this.$t("rules.exist", [this.$t("platform.name")])));
      } else {
        callback();
      }
    };
    var validateNameEdit = (rule, value, callback) => {
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("platform.name")]))
        );
        return;
      }
      const names = this.items.map((i) => i.name);
      if (names.includes(value) && this.row.name !== value) {
        callback(new Error(this.$t("rules.exist", [this.$t("platform.name")])));
      } else {
        callback();
      }
    };
    return {
      items: [],
      users: [],
      shops: [],
      tenant: null,
      taobaoStores: null,
      usedTaobaoStores: null,
      // 新增
      addDF: false,
      validateName: validateName,
      addObj: {
        name: null,
        prefix: null,
        storeOwnerId: null,
        importOrder: null,
        shopId: null,
        shopName: null,
        toHandOverAt: null,
        percent: 0,
        asyncTrack: false,
        importColor: true,
        importSize: true,
        mergeBargain: false,
        tbUserId: null,
      },
      saveDoing: false,
      // 编辑
      validateNameEdit: validateNameEdit,
      editDF: false,
      row: null,
      editObj: {
        name: null,
        prefix: null,
        storeOwnerId: null,
        importOrder: null,
        shopId: null,
        shopName: null,
        toHandOverAt: null,
        percent: 0,
        asyncTrack: false,
        importColor: true,
        importSize: true,
        mergeBargain: false,
        tbUserId: null,
      },
      editDoing: false,
      //
      subscribeDoing: false,
      clearSubscribeDoing: false,
      //
      updateCpCodeDF: false,
      updateCpCodeObj: {
        cpCode: null,
      },
      updateCpCodeSubmitDoing: false,
    };
  },

  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    self.loadData();
    axios
      .all([
        User.findByTenantId(self.Permit.currentTenant().id),
        Shop.findByTenantId(),
      ])
      .then(
        axios.spread(function (users, shops) {
          if (users.status === 200) {
            self.users = users.data.filter((r) => r.voidAt == null);
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
          } else {
            self.sysError();
          }
        })
      );
  },
  methods: {
    authorize(row) {
      const self = this;
      Cookies.setRowId(row.id);
      TaobaoStore.getAuthorizeUrl().then(function (res) {
        if (res.status === 200) {
          window.open(res.data);
        } else {
          self.sysError();
        }
      });
    },
    //
    updateCpCode(row) {
      const self = this;
      self.row = row;
      self.updateCpCodeObj.cpCode = row.cpCode;
      self.updateCpCodeSubmitDoing = false;
      self.updateCpCodeDF = true;
    },
    updateCpCodeSubmit() {
      const self = this;
      this.$refs.updateCpCodeObjForm.validate((valid) => {
        if (valid) {
          self.updateCpCodeSubmitDoing = true;
          TaobaoStore.updateCpCode(self.row.id, self.updateCpCodeObj).then(
            function (res) {
              self.updateCpCodeSubmitDoing = false;
              self.updateCpCodeDF = false;
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "success",
                });
                self.loadData();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    // 新增
    create() {
      const self = this;
      if (self.usedTaobaoStores >= self.taobaoStores) {
        self.$message({
          message: "淘宝平台数量已达上限，请去联系客服购买",
          type: "warning",
        });
        return;
      }
      self.addObj.name = null;
      self.addObj.prefix = null;
      self.addObj.importOrder = false;
      self.addObj.storeOwnerId = null;
      self.addObj.shopId = null;
      self.addObj.shopName = null;
      self.addObj.toHandOverAt = null;
      self.addObj.percent = null;
      self.addObj.tbUserId = null;
      self.addObj.asyncTrack = false;
      self.addObj.importColor = true;
      self.addObj.importSize = true;
      self.addObj.mergeBargain = false;
      self.addDF = true;
    },
    addSubmit() {
      const self = this;
      this.$refs.addObjForm.validate((valid) => {
        if (valid) {
          if (self.addObj.prefix === "") {
            self.addObj.prefix = null;
          }
          self.saveDoing = true;
          TaobaoStore.create(self.addObj).then(function (res) {
            self.saveDoing = false;
            self.addDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.usedTaobaoStores = self.usedTaobaoStores + 1;
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        TaobaoStore.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.usedTaobaoStores = self.usedTaobaoStores - 1;
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row, rowIndex) {
      const self = this;
      self.row = row;
      self.editObj.name = row.name;
      self.editObj.prefix = row.prefix;
      self.editObj.importOrder = row.importOrder;
      self.editObj.shopId = row.shopId;
      self.editObj.shopName = row.shopName;
      self.editObj.toHandOverAt = row.toHandOverAt;
      self.editObj.percent = row.percent;
      self.editObj.asyncTrack = row.asyncTrack;
      self.editObj.importColor = row.importColor;
      self.editObj.importSize = row.importSize;
      self.editObj.mergeBargain = row.mergeBargain;
      self.editObj.tbUserId = row.tbUserId;

      const selectedUser = self.users.find((u) => u.id === row.storeOwnerId);
      if (selectedUser != null) {
        self.editObj.storeOwnerId = row.storeOwnerId;
        self.adminDF = selectedUser.admin;
      }
      self.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          if (self.editObj.prefix == "") {
            self.editObj.prefix = null;
          }
          self.editObj.shopName = self.shops.find(
            (s) => s.id === self.editObj.shopId
          ).name;
          self.editDoing = true;
          TaobaoStore.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // updateUsedTaobaoStoreQty(qty) {
    //   const self = this;
    //   Charge.updateUsedTaobaoStore({ usedTaobaoStore: qty }).then(function (
    //     res
    //   ) {
    //     if (res.status === 200) {
    //       // console.log("====")
    //     } else {
    //       self.sysError();
    //     }
    //   });
    // },

    loadData() {
      const self = this;
      self.loadingStart();
      axios
        .all([
          TaobaoStore.findByTenantId(),
          Tenant.findById(self.Permit.currentTenant().id),
        ])
        .then(
          axios.spread(function (stores, tenant) {
            self.loadingEnd();
            if (stores.status === 200) {
              self.items = stores.data;
            } else {
              self.sysError();
            }
            if (tenant.data.code === 200) {
              self.tenant = tenant.data.entity;
              self.taobaoStores = self.tenant.charge.taobaoStores;
              self.usedTaobaoStores = self.tenant.charge.usedTaobaoStores;
            } else {
              self.sysError();
            }
          })
        );
    },
  },
};
</script>
